export enum AuditActionEnum {
  CREATE = 'create',
  UPDATE = 'update',
  DELETE = 'delete',
  DOWNLOAD = 'download',
  SEARCH = 'search',
}
